import Vue from 'vue';
import PxCamposProdutoTotvs from '@/modules/produtos/campos-erp/PxCamposProdutoTotvs.vue';
import PxCamposFornecedorTotvs
  from '@/modules/gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorTotvs.vue';
import PxCamposCompraTotvs from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraTotvs.vue';
import PxCamposCompraItemTableTotvs
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableTotvs.vue';
import PxCamposCompraViewTotvs from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewTotvs.vue';
import PxCamposCompraProdutosViewTotvs
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewTotvs.vue';
import PxCamposCompraItemTotvs from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemTotvs.vue';
import PxCamposCompraNeo from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraNeo.vue';
import PxCamposCompraItemTableNeo
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableNeo.vue';
import PxCamposCompraProdutosViewNeo
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewNeo.vue';
import PxCamposCompraItemNeo from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemNeo.vue';
import PxCamposCompraSankhya
  from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraSankhya.vue';
import PxCamposCompraViewSankhya from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewSankhya.vue';
import PxCamposCompraItemTableSankhya
  from '@/modules/carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableSankhya.vue';
import PxCamposCompraItemSankhya from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemSankhya.vue';
import PxCamposProdutoNeo from '@/modules/produtos/campos-erp/PxCamposProdutoNeo.vue';
import PxCamposProdutoSankhya from '@/modules/produtos/campos-erp/PxCamposProdutoSankhya.vue';
import PxCamposFornecedorNeo
  from '@/modules/gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorNeo.vue';
import PxCamposFornecedorSankhya
  from '@/modules/gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorSankhya.vue';
import PxCamposCompraProjedata
  from '@/modules/carrinho/finalizacao/campos-erp/PxCamposCompraProjedata.vue';
import PxCamposCompraViewProjedata
  from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewProjedata.vue';
import PxCamposCompraProdutosViewProjedata
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewProjedata.vue';
import PxCamposCompraItemM8 from '@/modules/compra/cadastro/campos-erp/PxCamposCompraItemM8.vue';
import PxCamposCompraViewM8
  from '@/modules/compra/detalhes/views-erp/compra/PxCamposCompraViewM8.vue';
import PxCamposCompraProdutosViewM8
  from '@/modules/compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewM8.vue';
import PxCamposRequisicaoItemTotvs
  from '@/modules/requisicao/cadastro/campos-erp/PxCamposRequisicaoItemTotvs.vue';
import PxCamposRequisicaoProdutosViewTotvs
  from '@/modules/requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewTotvs.vue';
import PxCamposCompraUseallSetup from './carrinho/finalizacao/campos-erp/PxCamposCompraUseallSetup.vue';
import PxCamposCompraViewUseallSetup from './compra/detalhes/views-erp/compra/PxCamposCompraViewUseallSetup.vue';
import PxCamposCompraItemTableUseallSetup from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableUseallSetup.vue';
import PxCamposProdutoUseallSetup from './produtos/campos-erp/PxCamposProdutoUseallSetup.vue';
import PxCamposCompraItemUseallSetup from './compra/cadastro/campos-erp/PxCamposCompraItemUseallSetup.vue';
import PxCamposCompraProdutosViewUseallSetup from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewUseallSetup.vue';
import PxCamposCompraItemTableSenior from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableSenior.vue';
import PxCamposCompraSenior from './carrinho/finalizacao/campos-erp/PxCamposCompraSenior.vue';
import PxCamposProdutoSenior from './produtos/campos-erp/PxCamposProdutoSenior.vue';
import PxCamposFornecedorSenior from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorSenior.vue';
import PxCamposCompraItemSenior from './compra/cadastro/campos-erp/PxCamposCompraItemSenior.vue';
import PxCamposCompraProdutosViewSenior from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSenior.vue';
import PxCamposCompraViewSenior from './compra/detalhes/views-erp/compra/PxCamposCompraViewSenior.vue';
import PxCamposCompraItemSeniorTeixeira from './compra/cadastro/campos-erp/PxCamposCompraItemSeniorTeixeira.vue';
import PxCamposCompraSeniorTeixeira from './carrinho/finalizacao/campos-erp/PxCamposCompraSeniorTeixeira.vue';
import PxCamposProdutoSeniorTeixeira from './produtos/campos-erp/PxCamposProdutoSeniorTeixeira.vue';
import PxCamposCompraItemTableSeniorTeixeira from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableSeniorTeixeira.vue';
import PxCamposCompraProdutosViewSeniorTeixeira from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSeniorTeixeira.vue';
import PxCamposCompraViewSeniorTeixeira from './compra/detalhes/views-erp/compra/PxCamposCompraViewSeniorTeixeira.vue';
import PxCamposFornecedorSeniorTeixeira from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorSeniorTeixeira.vue';
import PxCamposCompraItemLm from './compra/cadastro/campos-erp/PxCamposCompraItemLm.vue';
import PxCamposCompraLm from './carrinho/finalizacao/campos-erp/PxCamposCompraLm.vue';
import PxCamposCompraM8 from './carrinho/finalizacao/campos-erp/PxCamposCompraM8.vue';
import PxCamposProdutoLm from './produtos/campos-erp/PxCamposProdutoLm.vue';
import PxCamposCompraItemTableLm from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableLm.vue';
import PxCamposCompraViewLm from './compra/detalhes/views-erp/compra/PxCamposCompraViewLm.vue';
import PxCamposFornecedorLm from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorLm.vue';
import PxCamposCompraProdutosViewLm from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewLm.vue';
import PxCamposCompraItemUseall from './compra/cadastro/campos-erp/PxCamposCompraItemUseall.vue';
import PxCamposCompraUseall from './carrinho/finalizacao/campos-erp/PxCamposCompraUseall.vue';
import PxCamposCompraItemTableUseall from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableUseall.vue';
import PxCamposCompraViewUseall from './compra/detalhes/views-erp/compra/PxCamposCompraViewUseall.vue';
import PxCamposFornecedorUseall from './gestao-fornecedor/gestao/campos-erp/PxCamposFornecedorUseall.vue';
import PxCamposProdutoUseall from './produtos/campos-erp/PxCamposProdutoUseall.vue';
import PxCamposCompraProdutosViewUseall from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewUseall.vue';
import PxCamposCompraViewNeo from './compra/detalhes/views-erp/compra/PxCamposCompraViewNeo.vue';
import PxCamposCompraItemProjedata from './compra/cadastro/campos-erp/PxCamposCompraItemProjedata.vue';
import PxCamposCompraItemNeoG7 from './compra/cadastro/campos-erp/PxCamposCompraItemNeoG7.vue';
import PxCamposCompraItemTableNeoG7 from './carrinho/finalizacao/item-campos-erp/PxCamposCompraItemTableNeoG7.vue';
import PxCamposCompraProdutosViewNeoG7 from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewNeoG7.vue';
import PxCamposProdutoNeoG7 from './produtos/campos-erp/PxCamposProdutoNeoG7.vue';
import PxCamposRequisicaoItemCrmSolucoes from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemCrmSolucoes.vue';
import PxCamposRequisicaoProdutosViewCrmSolucoes from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewCrmSolucoes.vue';
import PxCamposProdutoCrmSolucoes from './produtos/campos-erp/PxCamposProdutoCrmSolucoes.vue';
import PxCamposCompraItemCrmSolucoes from './compra/cadastro/campos-erp/PxCamposCompraItemCrmSolucoes.vue';
import PxCamposCompraProdutosViewCrmSolucoes from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewCrmSolucoes.vue';
import PxCamposProdutoFocco from './produtos/campos-erp/PxCamposProdutoFocco.vue';
import PxCamposCompraItemFocco from './compra/cadastro/campos-erp/PxCamposCompraItemFocco.vue';
import PxCamposCompraProdutosViewFocco from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewFocco.vue';
import PxCamposRequisicaoItemFocco from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemFocco.vue';
import PxCamposRequisicaoProdutosViewFocco from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewFocco.vue';
import PxCamposCotacaoItemFocco from './cotacao/cadastro/produtos/campos-erp/PxCamposCotacaoItemFocco.vue';
import PxCamposCotacaoProdutosViewFocco from './cotacao/resposta/detalhes/views-erp/PxCamposCotacaoProdutosViewFocco.vue';
import PxCamposRequisicaoItemSeniorMega from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemSeniorMega.vue';
import PxCamposProdutoSeniorMega from './produtos/campos-erp/PxCamposProdutoSeniorMega.vue';
import PxCamposCompraItemSeniorMega from './compra/cadastro/campos-erp/PxCamposCompraItemSeniorMega.vue';
import PxCamposRequisicaoProdutosViewSeniorMega from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewSeniorMega.vue';
import PxCamposCompraProdutosViewSeniorMega from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewSeniorMega.vue';
import PxCamposCompraItemNeoGabriella from './compra/cadastro/campos-erp/PxCamposCompraItemNeoGabriella.vue';
import PxCamposProdutoNeoGabriella from './produtos/campos-erp/PxCamposProdutoNeoGabriella.vue';
import PxCamposCompraViewNeoGabriella from './compra/detalhes/views-erp/compra/PxCamposCompraViewNeoGabriella.vue';
import PxCamposCompraItemCasaShopping from './compra/cadastro/campos-erp/PxCamposCompraItemCasaShopping.vue';
import PxCamposCompraNeoGabriella from './carrinho/finalizacao/campos-erp/PxCamposCompraNeoGabriella.vue';
import PxCamposProdutoCasaShopping from './produtos/campos-erp/PxCamposProdutoCasaShopping.vue';
import PxCamposRequisicaoItemCasaShopping from './requisicao/cadastro/campos-erp/PxCamposRequisicaoItemCasaShopping.vue';
import PxCamposRequisicaoProdutosViewCasaShopping from './requisicao/detalhes/campos-erp/PxCamposRequisicaoProdutosViewCasaShopping.vue';
import PxCamposCompraProdutosViewCasaShopping from './compra/detalhes/views-erp/produto/PxCamposCompraProdutosViewCasaShopping.vue';
import PxCamposCotacaoItemCasaShopping from './cotacao/cadastro/produtos/campos-erp/PxCamposCotacaoItemCasaShopping.vue';
import PxCamposCotacaoProdutosViewCasaShopping from './cotacao/resposta/detalhes/views-erp/PxCamposCotacaoProdutosViewCasaShopping.vue';

// Campos Totvs
Vue.component('PxCamposProdutoTotvs', PxCamposProdutoTotvs);
Vue.component('PxCamposFornecedorTotvs', PxCamposFornecedorTotvs);
Vue.component('PxCamposCompraTotvs', PxCamposCompraTotvs);
Vue.component('PxCamposCompraItemTableTotvs', PxCamposCompraItemTableTotvs);
Vue.component('PxCamposCompraViewTotvs', PxCamposCompraViewTotvs);
Vue.component('PxCamposCompraProdutosViewTotvs', PxCamposCompraProdutosViewTotvs);
Vue.component('PxCamposCompraItemTotvs', PxCamposCompraItemTotvs);
Vue.component('PxCamposRequisicaoItemTotvs', PxCamposRequisicaoItemTotvs);
Vue.component('PxCamposRequisicaoProdutosViewTotvs', PxCamposRequisicaoProdutosViewTotvs);

// Campos NEO
Vue.component('PxCamposCompraNeo', PxCamposCompraNeo);
Vue.component('PxCamposCompraItemTableNeo', PxCamposCompraItemTableNeo);
Vue.component('PxCamposCompraProdutosViewNeo', PxCamposCompraProdutosViewNeo);
Vue.component('PxCamposCompraItemNeo', PxCamposCompraItemNeo);
Vue.component('PxCamposProdutoNeo', PxCamposProdutoNeo);
Vue.component('PxCamposFornecedorNeo', PxCamposFornecedorNeo);
Vue.component('PxCamposCompraViewNeo', PxCamposCompraViewNeo);

// Campos NEO com personalização para G7
Vue.component('PxCamposCompraItemNeoG7', PxCamposCompraItemNeoG7);
Vue.component('PxCamposCompraItemTableNeoG7', PxCamposCompraItemTableNeoG7);
Vue.component('PxCamposCompraProdutosViewNeoG7', PxCamposCompraProdutosViewNeoG7);
Vue.component('PxCamposProdutoNeoG7', PxCamposProdutoNeoG7);

// Campos NEO com personalização para Gabriealla
Vue.component('PxCamposCompraItemNeoGabriella', PxCamposCompraItemNeoGabriella);
Vue.component('PxCamposProdutoNeoGabriella', PxCamposProdutoNeoGabriella);
Vue.component('PxCamposCompraProdutosViewNeoGabriella', PxCamposCompraProdutosViewNeo);
Vue.component('PxCamposCompraNeoGabriella', PxCamposCompraNeoGabriella);
Vue.component('PxCamposCompraViewNeoGabriella', PxCamposCompraViewNeoGabriella);

// Campos Sankhyaz
Vue.component('PxCamposCompraSankhya', PxCamposCompraSankhya);
Vue.component('PxCamposCompraViewSankhya', PxCamposCompraViewSankhya);
Vue.component('PxCamposCompraItemTableSankhya', PxCamposCompraItemTableSankhya);
Vue.component('PxCamposCompraItemSankhya', PxCamposCompraItemSankhya);
Vue.component('PxCamposProdutoSankhya', PxCamposProdutoSankhya);
Vue.component('PxCamposFornecedorSankhya', PxCamposFornecedorSankhya);

// Campos Senior
Vue.component('PxCamposCompraSenior', PxCamposCompraSenior);
Vue.component('PxCamposCompraViewSenior', PxCamposCompraViewSenior);
Vue.component('PxCamposCompraItemTableSenior', PxCamposCompraItemTableSenior);
Vue.component('PxCamposCompraItemSenior', PxCamposCompraItemSenior);
Vue.component('PxCamposProdutoSenior', PxCamposProdutoSenior);
Vue.component('PxCamposFornecedorSenior', PxCamposFornecedorSenior);
Vue.component('PxCamposCompraProdutosViewSenior', PxCamposCompraProdutosViewSenior);

// Campos Senior Teixeira
Vue.component('PxCamposCompraItemSeniorTeixeira', PxCamposCompraItemSeniorTeixeira);
Vue.component('PxCamposCompraSeniorTeixeira', PxCamposCompraSeniorTeixeira);
Vue.component('PxCamposProdutoSeniorTeixeira', PxCamposProdutoSeniorTeixeira);
Vue.component('PxCamposCompraItemTableSeniorTeixeira', PxCamposCompraItemTableSeniorTeixeira);
Vue.component('PxCamposCompraProdutosViewSeniorTeixeira', PxCamposCompraProdutosViewSeniorTeixeira);
Vue.component('PxCamposCompraViewSeniorTeixeira', PxCamposCompraViewSeniorTeixeira);
Vue.component('PxCamposFornecedorSeniorTeixeira', PxCamposFornecedorSeniorTeixeira);

// Campos LM
Vue.component('PxCamposCompraItemLm', PxCamposCompraItemLm);
Vue.component('PxCamposCompraLm', PxCamposCompraLm);
Vue.component('PxCamposProdutoLm', PxCamposProdutoLm);
Vue.component('PxCamposCompraItemTableLm', PxCamposCompraItemTableLm);
Vue.component('PxCamposCompraViewLm', PxCamposCompraViewLm);
Vue.component('PxCamposFornecedorLm', PxCamposFornecedorLm);
Vue.component('PxCamposCompraProdutosViewLm', PxCamposCompraProdutosViewLm);

// Campos Useall
Vue.component('PxCamposCompraItemUseall', PxCamposCompraItemUseall);
Vue.component('PxCamposCompraUseall', PxCamposCompraUseall);
Vue.component('PxCamposProdutoUseall', PxCamposProdutoUseall);
Vue.component('PxCamposCompraItemTableUseall', PxCamposCompraItemTableUseall);
Vue.component('PxCamposCompraViewUseall', PxCamposCompraViewUseall);
Vue.component('PxCamposFornecedorUseall', PxCamposFornecedorUseall);
Vue.component('PxCamposCompraProdutosViewUseall', PxCamposCompraProdutosViewUseall);

// Campos Useall Procer a unica personalização deles pelo ERP é a obrigatorieadade de campos.
Vue.component('PxCamposCompraItemUseallProcer', PxCamposCompraItemUseall);
Vue.component('PxCamposCompraUseallProcer', PxCamposCompraUseall);
Vue.component('PxCamposProdutoUseallProcer', PxCamposProdutoUseall);
Vue.component('PxCamposCompraItemTableUseallProcer', PxCamposCompraItemTableUseall);
Vue.component('PxCamposCompraViewUseallProcer', PxCamposCompraViewUseall);
Vue.component('PxCamposFornecedorUseallProcer', PxCamposFornecedorUseall);
Vue.component('PxCamposCompraProdutosViewUseallProcer', PxCamposCompraProdutosViewUseall);

// Campos Useall Setup
Vue.component('PxCamposCompraUseallSetup', PxCamposCompraUseallSetup);
Vue.component('PxCamposCompraViewUseallSetup', PxCamposCompraViewUseallSetup);
Vue.component('PxCamposCompraItemUseallSetup', PxCamposCompraItemUseallSetup);
Vue.component('PxCamposProdutoUseallSetup', PxCamposProdutoUseallSetup);
Vue.component('PxCamposCompraItemTableUseallSetup', PxCamposCompraItemTableUseallSetup);
Vue.component('PxCamposCompraProdutosViewUseallSetup', PxCamposCompraProdutosViewUseallSetup);
// Esses abaixo são os mesmos que usamos para Useall
Vue.component('PxCamposFornecedorUseallSetup', PxCamposFornecedorUseall);

// Campos M8
Vue.component('PxCamposCompraM8', PxCamposCompraM8);
Vue.component('PxCamposCompraItemM8', PxCamposCompraItemM8);
Vue.component('PxCamposCompraViewM8', PxCamposCompraViewM8);
Vue.component('PxCamposCompraProdutosViewM8', PxCamposCompraProdutosViewM8);

// Campos projedata
Vue.component('PxCamposCompraProjedata', PxCamposCompraProjedata);
Vue.component('PxCamposCompraItemProjedata', PxCamposCompraItemProjedata);
Vue.component('PxCamposCompraViewProjedata', PxCamposCompraViewProjedata);
Vue.component('PxCamposCompraProdutosViewProjedata', PxCamposCompraProdutosViewProjedata);

// Campos CRM Soluções
Vue.component('PxCamposRequisicaoItemCrmSolucoes', PxCamposRequisicaoItemCrmSolucoes);
Vue.component('PxCamposRequisicaoProdutosViewCrmSolucoes', PxCamposRequisicaoProdutosViewCrmSolucoes);
Vue.component('PxCamposProdutoCrmSolucoes', PxCamposProdutoCrmSolucoes);
Vue.component('PxCamposCompraItemCrmSolucoes', PxCamposCompraItemCrmSolucoes);
Vue.component('PxCamposCompraProdutosViewCrmSolucoes', PxCamposCompraProdutosViewCrmSolucoes);

// Campos Focco
Vue.component('PxCamposProdutoFocco', PxCamposProdutoFocco);
Vue.component('PxCamposCompraItemFocco', PxCamposCompraItemFocco);
Vue.component('PxCamposCompraProdutosViewFocco', PxCamposCompraProdutosViewFocco);
Vue.component('PxCamposRequisicaoItemFocco', PxCamposRequisicaoItemFocco);
Vue.component('PxCamposRequisicaoProdutosViewFocco', PxCamposRequisicaoProdutosViewFocco);
Vue.component('PxCamposCotacaoItemFocco', PxCamposCotacaoItemFocco);
Vue.component('PxCamposCotacaoProdutosViewFocco', PxCamposCotacaoProdutosViewFocco);

// Campos Senior mega
Vue.component('PxCamposRequisicaoItemSeniorMega', PxCamposRequisicaoItemSeniorMega);
Vue.component('PxCamposProdutoSeniorMega', PxCamposProdutoSeniorMega);
Vue.component('PxCamposCompraItemSeniorMega', PxCamposCompraItemSeniorMega);
Vue.component('PxCamposRequisicaoProdutosViewSeniorMega', PxCamposRequisicaoProdutosViewSeniorMega);
Vue.component('PxCamposCompraProdutosViewSeniorMega', PxCamposCompraProdutosViewSeniorMega);

// Campos Casa shopping
Vue.component('PxCamposCompraItemCasaShopping', PxCamposCompraItemCasaShopping);
Vue.component('PxCamposProdutoCasaShopping', PxCamposProdutoCasaShopping);
Vue.component('PxCamposRequisicaoItemCasaShopping', PxCamposRequisicaoItemCasaShopping);
Vue.component('PxCamposRequisicaoProdutosViewCasaShopping', PxCamposRequisicaoProdutosViewCasaShopping);
Vue.component('PxCamposCompraProdutosViewCasaShopping', PxCamposCompraProdutosViewCasaShopping);
Vue.component('PxCamposCotacaoItemCasaShopping', PxCamposCotacaoItemCasaShopping);
Vue.component('PxCamposCotacaoProdutosViewCasaShopping', PxCamposCotacaoProdutosViewCasaShopping);
